import api from './api';

export const adminService = {
    list: async (filterData: any) => {
        const params = new URLSearchParams();
        
        if (filterData.page) {
            params.set('page', filterData.page.toString());
        }
        if (filterData.limit) {
            params.set('limit', filterData.limit.toString());
        }
        if (filterData.search) {
            params.set('search', filterData.search);
        }
        if (filterData.sort?.column) {
            params.set('sort', filterData.sort.column);
            if (filterData.sort.dir) {
                params.set('order', filterData.sort.dir);
            }
        }
        
        const response = await api.get(`admins?${params.toString()}`);
        return response.data;
    },
    
    add: async (adminData: any) => {
        const response = await api.post('admins/', adminData);
        return response.data;
    },
    
    getDetails: async (adminId: string) => {
        const response = await api.get(`admins/${adminId}`);
        return response.data;
    },
    
    edit: async (adminId: string, adminData: any) => {
        const response = await api.put(`admins/${adminId}`, adminData);
        return response.data;
    },
    
    updateStatus: async (adminId: string, data: any) => {
        const response = await api.patch(`admins/${adminId}/toggle`, data);
        return response.data;
    },
    
    delete: async (adminId: string) => {
        const response = await api.delete(`admins/${adminId}`);
        return response.data;
    },
    
    dashboard: async () => {
        const response = await api.get('dashboard');
        return response.data;
    }
};
